import React from 'react';
import { Crosshair, RotateCcw, Zap } from 'lucide-react';

interface DemoScenarioItemsProps {
  onStorm: () => void;
  onNeedle: () => void;
  onReset: () => void;
  /** A storm is running: it cannot be started twice. */
  storming?: boolean;
  /** Added to every entry (the account menu uses `c3-show-le1200` to show them only when the chip is hidden). */
  className?: string;
}

/**
 * The three demo scenarios as menu entries. They are shown in the Demo chip's menu and, at 1200 px and below,
 * in the account menu. The caller closes the menu when an entry is picked.
 */
const DemoScenarioItems: React.FC<DemoScenarioItemsProps> = ({ onStorm, onNeedle, onReset, storming, className }) => {
  const cls = `c3-nav-menu-item has-sub${className ? ` ${className}` : ''}`;
  return (
    <>
      <button type="button" className={cls} role="menuitem" disabled={storming} onClick={onStorm}>
        <span className="inline-flex items-center gap-2">
          <Zap size={16} strokeWidth={1.5} aria-hidden />
          Alert storm
        </span>
        <span className="c3-nav-menu-sub">
          {storming ? 'Storm in progress…' : 'Burst of 3,912 alerts, absorbed without paging analysts'}
        </span>
      </button>
      <button type="button" className={cls} role="menuitem" onClick={onNeedle}>
        <span className="inline-flex items-center gap-2">
          <Crosshair size={16} strokeWidth={1.5} aria-hidden />
          Needle in the haystack
        </span>
        <span className="c3-nav-menu-sub">Surface INC-4021 from correlated noise</span>
      </button>
      <button type="button" className={cls} role="menuitem" onClick={onReset}>
        <span className="inline-flex items-center gap-2">
          <RotateCcw size={16} strokeWidth={1.5} aria-hidden />
          Reset demo
        </span>
        <span className="c3-nav-menu-sub">Restore mock counters, incidents, and Agent Rank settings</span>
      </button>
    </>
  );
};

export default DemoScenarioItems;
